<template>
  <div class="container-form margin-top-30">
    <h4 class="section-name-form">Completează data și suma</h4>
    <div class="row">
      <div class="col-md-6 margin-top-15">
        <form-date
          input-name="date"
          :input-label="dateLabel"
          :input-value="dateObject"
          :setInput="setDate"
          :is-valid="validDate"
          :disabled="false"
          :error-text="dateInvalid"
        ></form-date>
      </div>
      <div class="col-md-6 margin-top-15">
        <form-input
          input-type="text"
          input-name="amount"
          :input-label="amountLabel"
          :input-value="amount"
          :setInput="setAmount"
          :is-valid="validAmount"
          :disabled="false"
          :error-text="amountInvalid"
        ></form-input>
      </div>
    </div>
    <div class="align-button-form margin-top-30">
      <button-form button-name="PASUL URMĂTOR" :on-click="nextStep"></button-form>
    </div>
  </div>
</template>

<script>
import FormInput from "../global/FormInput";
import FormDate from "../global/FormDate";
import ButtonForm from "../global/ButtonForm";
import { DATE_LABEL, AMOUNT_LABEL } from "../../content/FormLabels";
import { GENERAL_INVALID } from "../../content/FormErrors";
import { mapState, mapMutations } from "vuex";
import { notNull, isNumber } from "../../helpers/Validations";
import axios from "axios";

export default {
  components: {
    FormInput,
    ButtonForm,
    FormDate
  },
  data() {
    return {
      dateLabel: DATE_LABEL,
      amountLabel: AMOUNT_LABEL,
      dateInvalid: GENERAL_INVALID,
      amountInvalid: GENERAL_INVALID,
      vmodelexample: ""
    };
  },
  mounted() {
    this.$nextTick(function() {
      if (this.date.length === 0) {
        const date = new Date();
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;
        const formattedDate = year + "-" + month + "-" + day;
        this.setDate(formattedDate, date);
      }
    });
  },
  computed: {
    ...mapState({
      date: state => state.formInputs.date,
      dateObject: state => state.formInputs.dateObject,
      amount: state => state.formInputs.amount,
      validDate: state => state.isFormValid.date,
      validAmount: state => state.isFormValid.amount,
      formInputs: state => state.formInputs
    })
  },
  methods: {
    ...mapMutations([
      "addDate",
      "addDateObject",
      "addFileName",
      "addAmount",
      "isDateValid",
      "isAmountValid",
      "incrementWizardStep",
    ]),
    setDate: function(date, dateObject) {
      if (this.date !== date) {
        this.addDate(date);
        this.addDateObject(dateObject);
      }
    },
    setAmount: function(event) {
      if (this.amount != event.target.value.trim())
        this.addAmount(event.target.value.trim());
    },
    nextStep: function() {
      const isDateValid = notNull(this.date);
      this.isDateValid(isDateValid);

      const isAmountValid = isNumber(this.amount);
      this.isAmountValid(isAmountValid);

      if (isDateValid && isAmountValid) {
          this.incrementWizardStep();
      }
    }
  }
};
</script>

